module.exports = __webpack_public_path__ + "caf577ed2ad6a0812378a32c779cee88.jpg";